import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '~/assets/img/Tryon-Express-Logo.png';
import { MdDashboard, MdFace, MdLaptop } from 'react-icons/md';
import { IoMdBasket } from 'react-icons/io';
import {FaBookReader, FaUserFriends} from 'react-icons/fa';
import { RiDoorOpenFill } from 'react-icons/ri';
import { ROLES } from '~/util/auth';
import { DropDown } from '~/components';
import { useAuth } from '~/hooks';


const Header = () => {
    // const { hasRole } = useAuth();
    
    return (
        <header className="bg-gradient-to-r from-blue-medium to to-blue-dark fixed w-screen z-20">
            <div className="container flex h-20 items-center">
                <Link to="/">
                    <img src={Logo} className="h-12 mb-2 mr-8" />
                </Link>
                <Link to="/" className="flex items-center text-white self-stretch align-baseline px-4 ml-4">
                    <MdDashboard className="mr-1.5" size="1.25rem" />
                    <span>Dashboard</span>
                </Link>
                <Link to="/orderhistory" className="flex items-center text-white self-stretch align-baseline px-4 ml-4">
                    <IoMdBasket className="mr-1.5" size="1.375rem" />
                    <span>Order History</span>
                </Link>
                <Link to="/resources" className="flex items-center text-white self-stretch px-4 ml-4">
                    <FaBookReader className="mr-1.5" size="1.125rem" />
                    <span>Resources</span>
                </Link>
                {/*{(hasRole(ROLES.ADMIN)) &&*/}
                {/*    <Link to="/export" className="flex items-center text-white self-stretch px-4 ml-4">*/}
                {/*        <FaFileExport className="mr-1.5" size="1.125rem"/>*/}
                {/*        <span>Export</span>*/}
                {/*    </Link>*/}
                {/*}*/}
                <UserMenu />
            </div>
        </header>
    );
};

export default Header;

function UserMenu() {
    const { user, logout, hasRole } = useAuth();

    const Label = () => (
        <React.Fragment>
            {user.firmName && (
                <React.Fragment>
                    <span className="text-white text-sm">{user.firmName}</span>
                    <span className="text-white mx-3 font-light"> | </span>
                </React.Fragment>
            )}
            <span className="text-white text-sm">Hi, {`${user.name}`} </span>
        </React.Fragment>
    );

    return (
        <DropDown
            className="ml-auto my-4 self-stretch flex"
            wrapperClass="bg-white rounded shadow-md right-0 top-full"
            buttonClass="flex items-center focus:outline-none"
            iconClass="text-blue-30 ml-2"
            text={Label}>
            <section className="flex flex-col items-stretch w-64 text-gray-80">
                <Link to="/editprofile" className="p-2 px-4 rounded-t hover:bg-blue-10 flex items-center">
                    <MdFace />
                    <span className="ml-2 ">My Profile</span>
                </Link>
                {(hasRole(ROLES.ADMIN) || hasRole(ROLES.FIRM_ADMIN)) &&
                    <Link to="/useradmin" className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <FaUserFriends />
                        <span className="ml-2 ">User Administration</span>
                    </Link>
                }
                {(hasRole(ROLES.ADMIN)) &&
                    <Link to="/siteadmin" className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdLaptop />
                        <span className="ml-2 ">Site Administration</span>
                    </Link>
                }
                <button className="py-2 px-4 rounded-b hover:bg-blue-10 flex items-center" onClick={() => logout()}>
                    <RiDoorOpenFill />
                    <span className="ml-2 ">Log Out</span>
                </button>
            </section>
        </DropDown>
    );
}